/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitMenuOrderBody
 */
export interface SubmitMenuOrderBody {
    /**
     * 
     * @type {string}
     * @memberof SubmitMenuOrderBody
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitMenuOrderBody
     */
    hash?: string;
}

export function SubmitMenuOrderBodyFromJSON(json: any): SubmitMenuOrderBody {
    return SubmitMenuOrderBodyFromJSONTyped(json, false);
}

export function SubmitMenuOrderBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitMenuOrderBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'hash': !exists(json, 'hash') ? undefined : json['hash'],
    };
}

export function SubmitMenuOrderBodyToJSON(value?: SubmitMenuOrderBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'hash': value.hash,
    };
}


